// src/hooks/useVoiceReport.jsx
import { useState } from "react";
import { API_ENDPOINT } from "../../utils/constants";
import { getToken } from "../../utils/util";
import { toast } from "react-toastify";

export const useVoiceReport = () => {
  const [generating, setGenerating] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const generateAndDownloadReport = async (campaignId, reportType = "full") => {
    setGenerating(true);
    try {
      // 1. Generate report
      const genRes = await fetch(
        `${API_ENDPOINT}/voice/voice-campaigns/report/generate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({ campaignId, reportType }),
        }
      );

      if (!genRes.ok) throw new Error("Failed to generate report");

      const genData = await genRes.json();

      // Adjust these keys according to your exact backend response
      const reportId =
        genData?.data?.reportId ||
        genData?.data?.id ||
        genData?.reportId ||
        genData?.id;

      if (!reportId) throw new Error("No reportId received");

      // 2. Download the file
      setGenerating(false);
      setDownloading(true);

      const downloadRes = await fetch(
        `${API_ENDPOINT}/voice/voice-campaigns/report/download/${reportId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      if (!downloadRes.ok) throw new Error("Failed to download report");

      const blob = await downloadRes.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;

      const contentDisposition = downloadRes.headers.get("content-disposition");
      const filename = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
        : `campaign_report_${reportId}.xlsx`;

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      toast.success("Report downloaded successfully! 🎉");
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Something went wrong");
    } finally {
      setGenerating(false);
      setDownloading(false);
    }
  };

  return {
    generateAndDownloadReport,
    isGenerating: generating,
    isDownloading: downloading,
  };
};
